import React from "react";
import PropTypes from "prop-types";

function LogoImage(props) {
  const { item, defaultCompanyLogoImageUrl } = props;
  const image_url = item.logo_image ? item.logo_image : defaultCompanyLogoImageUrl;

  return (
    <span>
      <img
        height='60'
        width='60'
        className='img-thumbnail mr-3'
        src={image_url}
        alt={item.name}
      />
    </span>
  );
}

LogoImage.propTypes = {
  item: PropTypes.shape({
    logo_image: PropTypes.string
  }).isRequired,
  defaultCompanyLogoImageUrl: PropTypes.string.isRequired
};

export default LogoImage;
